import { render, staticRenderFns } from "./CertificateRequestTemplateEdit.vue?vue&type=template&id=2f8dbaed&scoped=true"
import script from "./CertificateRequestTemplateEdit.vue?vue&type=script&lang=js"
export * from "./CertificateRequestTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./CertificateRequestTemplateEdit.vue?vue&type=style&index=0&id=2f8dbaed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dbaed",
  null
  
)

export default component.exports